/**
 * @file index.tsx
 * @module app/modules/price-update-request/index
 * @description Implements the index workflow for price-update requests.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import PriceUpdateRequest from './price-update-request';
import PriceUpdateRequestDetail from './price-update-request-detail';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
const priceUpdateRequestBreadCrumbs: Array<PageLink> = [
  {
    title: 'Price Update Request',
    path: '/price-update-request',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const PriceUpdateRequestPage = () => (
  <Routes>
    <Route element={<Outlet />} />
    <Route
      index
      element={
        <>
          <PageTitle>
            Price Update Request
          </PageTitle>
          <PriceUpdateRequest />
        </>
      }
    />
    <Route
      path="detail"
      element={
        <>
          <PageTitle breadcrumbs={priceUpdateRequestBreadCrumbs}>
            Price Update Request Detail
          </PageTitle>
          <PriceUpdateRequestDetail />
        </>
      }
    />
  </Routes>
);

export default PriceUpdateRequestPage;
